import { TradeOrgPages } from "../types/tradeorgPages.ts";
import List from "./components/List.tsx";
import OrgLinks from "./components/OrgLinks.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const Mrf = () => {
  const pageName = TradeOrgPages.MRF;
  return (
    <Layout
      left={
        <>
          <Title title="Välj trygghet från MRF" subTitle="Bilen säljs av ett företag som är medlem i MRF." />
          <div className="mt-40 pb-40">
            <List
              title="Fördelar med att välja ett MRF-företag:"
              listElements={[
                "MRF är ett starkt varumärke som står för trygghet och seriositet.",
                "Du får alltid MRFs varudeklaration när du köper begagnad bil. Varudeklarationen är framtagen i samarbete med Konsumentverket och ger dig en tydlig bild av bilens skick och historia.",
                "Du får alltid MRFs leveransvillkor, som är godkända av Konsumentverket, vilket garanterar rättvisa och tydliga villkor.",
                "MRFs kundskydd gäller om det blir en tvist. Detta garanterar att du får den ersättning som Allmänna reklamationsnämnden (ARN) rekommenderar.",
                "MRF-garantin gäller alltid vid köp av begagnad bil. Du får ofta också en utökad garanti från bilföretaget.",
                "Endast företag som uppfyller våra högt ställda krav får bli medlemmar i MRF",
              ]}
            />
            <p className="mt-16 mb-0 text-m">
              <a href="https://www.mrf.se/medlem/sok-medlem/" target="_blank" rel="noopener">
                Kolla om företaget är med i MRF
              </a>
            </p>
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default Mrf;
